import { AfterViewInit, Component } from "@angular/core";
import "../style/app.scss";
import { AuthenticationService } from "./shared/authentication.service";
import {
  NavigationCancel,
  NavigationEnd,
  NavigationStart,
  Router,
} from "@angular/router";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "chatomatic",
  template: require('./app.component.html'),
  styles: [require('./app.component.scss')],
})
export class AppComponent implements AfterViewInit {
  public loading: boolean = false;
  public isAuthenticated: boolean = false;

  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private titleService: Title
  ) {
    this.titleService.setTitle(window.location.hostname);
    this.auth.isAuthenticated().subscribe((authenticated: boolean) => {
      this.isAuthenticated = authenticated;
    });
  }

  public ngAfterViewInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel
      ) {
        this.loading = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/app.component.ts